require('./cmIntervenerList.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const CmIntervenerItem = require('../cmIntervenerItem/cmIntervenerItem');
// @ constants
const { CM_INTERVENER_ITEM_TITULAR } = require('../../../constants/constants');
const { BROKER_CONTRACT_OWNER } = require('constants/index');

class CmIntervenerList extends React.Component {
    constructor(props) {
        super(props);
        this.hasOnlyOneOwner = this.hasOnlyOneOwner.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
        this.buildLinkActions = this.buildLinkActions.bind(this);
        this.handleIntervenerNameChange = this.handleIntervenerNameChange.bind(
            this,
        );
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(
            this,
        );
        this.handleIntervenerRemove = this.handleIntervenerRemove.bind(this);
        this.handleIntervenerAddClick = this.handleIntervenerAddClick.bind(
            this,
        );
        this.handleRestoreDefaultClick = this.handleRestoreDefaultClick.bind(
            this,
        );
    }

    hasOnlyOneOwner(currentInterveners) {
        const onlyOwnersList = currentInterveners.filter(intervener => {
            return intervener.get('type') === CM_INTERVENER_ITEM_TITULAR;
        });

        return onlyOwnersList.size <= 1;
    }

    buildIntervenerList() {
        const {
            immStocksContractForm,
            limitIntervenerOptions,
            showRemoveIcon,
        } = this.props;
        const currentInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'interveners',
        ]);
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners',
        ]);
        const availableInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'availableInterveners',
        ]);
        const hasOnlyOneOwner = this.hasOnlyOneOwner(currentInterveners);

        return currentInterveners.map((intervener, index) => {
            const interveners = availableInterveners.push(intervener);
            const isOnlyOwner =
                hasOnlyOneOwner &&
                intervener.get('type') === CM_INTERVENER_ITEM_TITULAR;
            return (
                <CmIntervenerItem
                    key={index}
                    index={index}
                    originalInterveners={interveners}
                    intervenerName={intervener.get('name')}
                    intervenerType={intervener.get('type')}
                    originaIntervenerType={intervener.get('originalType')}
                    onIntervenerNameChange={this.handleIntervenerNameChange}
                    onIntervenerTypeChange={this.handleIntervenerTypeChange}
                    onIntervenerRemove={this.handleIntervenerRemove}
                    isOnlyIntervener={originalInterveners.size === 1}
                    isOnlyOwner={isOnlyOwner}
                    nameLabelFormat={false}
                    limitIntervenerOptions={limitIntervenerOptions}
                    showRemoveIcon={!isOnlyOwner}
                />
            );
        });
    }

    handleIntervenerNameChange(index, name) {
        const { immStocksContractForm, allowSetIntervenerName } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners',
        ]);
        if (allowSetIntervenerName) {
            this.props.setIntervenerName(index, name, originalInterveners);
        }
    }

    handleIntervenerTypeChange(index, type) {
        this.props.setIntervenerType(index, type);
    }

    handleIntervenerRemove(index) {
        const { immStocksContractForm, removeIntervener } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners',
        ]);
        removeIntervener(index, originalInterveners);
    }

    handleIntervenerAddClick(e) {
        e.preventDefault();
        this.props.addIntervener();
    }

    handleRestoreDefaultClick(e) {
        e.preventDefault();
        const { immStocksContractForm } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners',
        ]);
        this.props.restoreDefaultInterveners(originalInterveners);
    }

    buildLinkActions() {
        const { immStocksContractForm } = this.props;
        const addIntervenerLabel = formatText(
            'broker-stockIntervenerAddIntervenerLabel',
        );
        const restoreValuesLabel = formatText(
            'broker-stockIntervenerRestoreValuesLabel',
        );
        const currentInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'interveners',
        ]);
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners',
        ]);

        if (
            currentInterveners &&
            originalInterveners &&
            currentInterveners.size !== originalInterveners.size
        ) {
            return (
                <div>
                    <OKButton
                        id="btnBrokerIntervenerListAddElement"
                        modifier="link-complementary"
                        onClick={this.handleIntervenerAddClick}
                    >
                        {addIntervenerLabel}
                    </OKButton>
                    <span className="intervener-list__action-links"> | </span>
                    <OKButton
                        id="btnBrokerIntervenerListRemoveElement"
                        modifier="link-complementary"
                        onClick={this.handleRestoreDefaultClick}
                    >
                        {restoreValuesLabel}
                    </OKButton>
                </div>
            );
        }
    }

    render() {
        const { intervernersListTitle, showTitleTooltip } = this.props;
        const intervenerList = this.buildIntervenerList();
        const linkActions = this.buildLinkActions();
        const tooltip = showTitleTooltip ? (
            <OKTooltip
                offset={[8, 0]}
                content="brokerIntevenerItem-tooltipFund"
                placement="right"
            />
        ) : null;

        return (
            <section className="cm-intervener-list">
                <header className="cm-intervener-list__header">
                    <h3 className="cm-intervener-list__title">
                        <FormattedText value={intervernersListTitle} />
                    </h3>
                    {tooltip}
                </header>

                <section className="cm-intervener-list__content">
                    {intervenerList}
                    {linkActions}
                </section>
            </section>
        );
    }
}

CmIntervenerList.propTypes = {
    originalInterveners: PropTypes.array,
    immStocksContractForm: PropTypes.object,
    immAccounts: PropTypes.object,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    requestAccountInterveners: PropTypes.func,
    limitIntervenerOptions: PropTypes.bool,
    showRemoveIcon: PropTypes.bool,
    originaIntervenerType: PropTypes.string,
    intervernersListTitle: PropTypes.string,
    showTitleTooltip: PropTypes.bool,
    allowSetIntervenerName: PropTypes.bool,
};

module.exports = CmIntervenerList;
